var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00891,
    y: 0.972656,
    width: 2,
    height: 22,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00891113,
    y: 14.9727,
    width: 6,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0089,
    y: 0.972656,
    width: 2,
    height: 22,
    rx: 1,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.00891,
    y: 3.97266,
    width: 6,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0089,
    y: 0.972656,
    width: 2,
    height: 22,
    rx: 1,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0089,
    y: 10.9727,
    width: 6,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSettings);
export default __webpack_public_path__ + "static/media/navbar-settings.380b66e90e0f0f058bc5f227871ac454.svg";
export { ForwardRef as ReactComponent };